<template>
  <v-dialog :value="value" max-width="500" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>Edit Expense</v-card-title>
      <v-card-text class="flex flex-col space-y-2.5">
        <base-snackbar :errors.sync="expensePutErrors" />
        <v-autocomplete v-model="expenseCategory" outlined="outlined" dense="dense" hide-details="auto"
                        :items="categories" label="Expense Category" item-value="id" item-text="description"
                        :error-messages="expensePutErrors.expense_category_id" return-object="return-object" />
        <v-text-field v-model="description" outlined="outlined" dense="dense" hide-details="auto"
                      label="description" :error-messages="expensePutErrors.description" />
        <v-text-field v-model.number="cost" outlined="outlined" dense="dense" hide-details="auto" label="Cost"
                      type="number" :error-messages="expensePutErrors.cost" />
        <v-text-field v-model="date" outlined="outlined" dense="dense" hide-details="auto" label="Date"
                      type="date" :error-messages="expensePutErrors.date" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text="text" @click="close">
          <span>cancel</span>
        </v-btn>
        <v-btn color="primary" dark="dark" :loading="expensePutting" @click="save">
          <span>save</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import VueRequestHandler from '@/classes/VueRequestHandler.class'
import requestVars from '@/extra-functions/request-vars.extra'
import expenseRepository from '@/repositories/expense.repository'

const [expensePutVars, expensePutVarNames] = requestVars({ identifier: 'expense', request: 'put', hasData: false })
const expensePutHandler = new VueRequestHandler(null, expensePutVarNames)

const inputVars = () => ({
  expenseCategory: {},
  description: null,
  cost: null,
  date: null,
})
export default {
  name: 'EditExpenses',
  props: {
    value: Boolean,
    expense: {
      type: Object,
      default: () => ({}),
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    ...inputVars(),
    ...expensePutVars,
  }),
  watch: {
    value(open) {
      if (open) this.seedFields()
    },
  },
  methods: {
    seedFields() {
      this.expensePutErrors = {}
      this.expenseCategory = this.expense.category || {}
      this.description = this.expense.description
      this.cost = this.expense.cost
      this.date = (this.expense.date || '').slice(0, 10)
    },
    save() {
      const handler = expensePutHandler
      const repository = expenseRepository.update
      const data = {
        store_id: this.$store.state.settings.storeId,
        expense_category_id: this.expenseCategory?.id ?? null,
        description: this.description,
        cost: this.cost,
        date: this.date,
      }
      handler.setVue(this)
      handler.execute(repository, [this.expense.id, data], this.updateStatusOk)
    },
    updateStatusOk() {
      this.$alertSwalSuccess('Expense updated successfully')
      this.$emit('update-success')
      this.close()
    },
    close() {
      this.expensePutErrors = {}
      this.$emit('input', false)
    },
  },
}
</script>
